import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {
  AccountStatusRedirectService,
  TRAVA_ABERTURA_PENDENTE_KEY,
} from '../services/account-status-redirect/account-status-redirect.service';
import { StorageService } from '../services/storage/storage.service';

export const guestGuard: CanActivateFn = async (_route, state) => {
  const router = inject(Router);
  const storage = inject(StorageService);
  const accountRedirect = inject(AccountStatusRedirectService);
  const jwt = await storage.get('jwt');
  if (!jwt) {
    return true;
  }

  // Em modo trava (abertura fria), a tela de senha e a recuperação são as
  // únicas rotas de auth liberadas para quem já está logado.
  const travaPendente = Boolean(await storage.get(TRAVA_ABERTURA_PENDENTE_KEY));
  if (travaPendente) {
    const url = state.url.split('?')[0];
    if (
      url.startsWith('/auth/login/password') ||
      url.startsWith('/auth/forgot-password')
    ) {
      return true;
    }
    return router.parseUrl('/auth/login/password');
  }

  const destino = await accountRedirect.resolveOnboardingDestino();
  return router.parseUrl(destino);
};
